<div class="date-picker-shipping-days-n-times">
  <form [formGroup]="formGroup">
    <div [formArrayName]="formArrayFieldName" class="column">
      @for (shippingDayControl of getFormArray().controls; track shippingDayControl; let i = $index) {
        <div class="flex-row" [formGroupName]="i">
          <pdq-checkbox
            [label]="shippingDayControl?.value?.day | dayToDisplayName"
            labelSize="small"
            style="width: 70px"
            formControlName="active"
            [checked]="shippingDayControl?.value?.active"></pdq-checkbox>
          <pdq-dropdown title="From" formControlName="from" [options]="times" [defaultOption]="times[0]"></pdq-dropdown>
          <pdq-dropdown
            title="To"
            formControlName="to"
            [options]="times | displayRelevantToTime: shippingDayControl.value.from"
            [defaultOption]="times[times.length - 1]"></pdq-dropdown>
          <pdq-input-arrows
            variant="form"
            [required]="false"
            formControlName="upToOrders"
            label="Up to orders a day"
            placeholder="unlimited"
            widthSize="auto"
            [min]="0"></pdq-input-arrows>
          <pdq-checkbox
            label="Skip as default selection"
            labelSize="small"
            icon="attention"
            description="Skips day from being calendar’s earliest default selection day"
            formControlName="skipDefaultSelection"
            [checked]="shippingDayControl?.value?.skipDefaultSelection"></pdq-checkbox>
        </div>
      }
    </div>
  </form>
</div>
